<template>
  <div>
    <page-header></page-header>
    <div class="body">
      <h1 id="description">{{ studio308.description }}</h1>
    </div>
    <div ref="subsections" id="sub-sections">
      <div id="services" class="sub-section align-left">
        <h1 class="heading">
          <router-link :to="'services'" exact>Services</router-link>
        </h1>
        <h2 class="hover-light">We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.</h2>
        <ul class="unstyled">
          <li v-for="(service, index) in menuServices" :key="index">
            <router-link :to="'services'+service.hash" exact>{{ service.title }}</router-link>
          </li>
        </ul>
      </div>
      <div v-if="projects.length" id="projects" class="sub-section align-right">
        <h1 class="heading">
          <router-link :to="'projects'">Projects</router-link>
        </h1>
        <h2 class="hover-light">Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.</h2>
        <ul class="unstyled">
          <li v-for="(project, index) in projects" :key="index" @click="scrollTop">
            <router-link :to="'projects'" exact>
              <span class="side-notes">
                <span v-for="(type, typeIndex) in project.types" :key="typeIndex" class="side-note">{{ type.title }}</span>
              </span>
              {{ project.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import PageHeader from '@/components/PageHeader'
export default {
  name: 'home',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      studio308: DataStore.studio308,
      projects: DataStore.projects,
      services: DataStore.services
    }
  },
  computed: {
    menuServices () {
      return this.services.slice(0, 4)
    }
  },
  methods: {
    scrollTop () {
      this.$scrollTo('html, body')
    }
  },
  components: {
    PageHeader
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss
  @import ../assets/styles/scss/mixins.scss

  .side-note
    color: $grey
    margin-right: 5px
    font-size: .7em
    @include transitions(0.3s)

  a:hover
    .side-note
      color: $lightGrey
</style>




// WEBPACK FOOTER //
// Home.vue?f29aaa10